import AgencyHeader from "../components/agency/AgencyHeader";
import AgencyHero from "../components/agency/AgencyHero";
import AgencyProblem from "../components/agency/AgencyProblem";
import AgencyServices from "../components/agency/AgencyServices";
import AgencyProcess from "../components/agency/AgencyProcess";
import AgencyPricing from "../components/agency/AgencyPricing";
import AgencyDemo from "../components/agency/AgencyDemo";
import AgencyContact from "../components/agency/AgencyContact";
import AgencyFooter from "../components/agency/AgencyFooter";
import { PageProvider } from "../config/PageContext";

export default function AgencyHomePage() {
  return (
    <PageProvider value="AGENCY">
      <div
        className="min-h-screen bg-[#0B0F1A] text-white font-body overflow-x-hidden selection:bg-brand-yellow selection:text-brand-yellowFg"
        data-testid="agency-home-page"
      >
        <AgencyHeader />
        <main>
          <AgencyHero />
          <AgencyProblem />
          <AgencyServices />
          <AgencyProcess />
          <AgencyPricing />
          <AgencyDemo />
          <AgencyContact />
        </main>
        <AgencyFooter />
      </div>
    </PageProvider>
  );
}
